<template>
  <div class="instructor-single-details ptb-100" v-if="instructor">
    <div class="container">
      <div class="row">
        <!-- SOL TARAF -->
        <div class="col-lg-4">
          <div class="instructor-sidebar-sticky">
            <div class="image">
              <img :src="instructor.image" :alt="instructor.name" />
            </div>
            <div class="content">
              <div class="instructor-content">
                <h3>{{ instructor.name }}</h3>
                <p>{{ instructor.bio }}</p>
              </div>
              <div class="instructor-info">
                <ul>
                  <li>
                    <i class="bx bx-envelope"></i>
                    <span>{{ instructor.email }}</span>
                  </li>
                  <li>
                    <i class="bx bx-phone"></i>
                    <span>{{ instructor.phone }}</span>
                  </li>
                  <li>
                    <i class="bx bx-map"></i>
                    <span>{{ instructor.address }}</span>
                  </li>
                </ul>
              </div>
              <div class="instructor-social" v-if="instructor.socials">
                <h4>Beni Takip Et:</h4>
                <ul>
                  <li v-if="instructor.socials.facebook">
                    <a :href="instructor.socials.facebook" target="_blank">
                      <img src="@/assets/img/icon/fb.svg" alt="facebook" />
                    </a>
                  </li>
                  <li v-if="instructor.socials.instagram">
                    <a :href="instructor.socials.instagram" target="_blank">
                      <img src="@/assets/img/icon/ins.svg" alt="instagram" />
                    </a>
                  </li>
                  <li v-if="instructor.socials.twitter">
                    <a :href="instructor.socials.twitter" target="_blank">
                      <img src="@/assets/img/icon/tw.svg" alt="twitter" />
                    </a>
                  </li>
                  <li v-if="instructor.socials.pinterest">
                    <a :href="instructor.socials.pinterest" target="_blank">
                      <img src="@/assets/img/icon/pn.svg" alt="pinterest" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- SAĞ TARAF -->
        <div class="col-lg-8">
          <div class="instructor-single-content">
            <h2>{{ instructor.name }}</h2>
            <p class="sub-title">{{ instructor.title }}</p>
            <p>{{ instructor.bio }}</p>
            <p>{{ instructor.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Instructor bulunamazsa -->
  <div v-else class="container ptb-100">
    <h2>Eğitmen bulunamadı.</h2>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useRoute } from "vue-router";
import teamData, { Instructor } from "../../data/teamData";

export default defineComponent({
  name: "InstructorDetails",
  setup() {
    const route = useRoute();
    const id = Number(route.params.id);
    const instructor: Instructor | undefined = teamData.find(
      (t: Instructor) => t.id === id
    );

    return { instructor };
  },
});
</script>
